<template>

    <div class="container register-page">
        <div class="row">
            <div class="offset-lg-3 col-lg-6 bg-ss-gray">
                <h2>{{ lang('all.wachtwoord_vergeten') }}</h2>

                <p>{{ lang('all.indien_je_geen_toegang_meer_hebt_tot_jouw_account') }}</p>
                <p>{{ lang('all.je_zult_na_het_invullen_van_het_formulier_een_emai') }}</p>

                <text-input
                    label=""
                    type="email"
                    placeholder="E-mailadres"
                    v-model="form.email"
                    :errors="errors.email"
                    @onEnter="resetPassword"
                ></text-input>

                <button
                    class="btn btn-primary"
                    :disabled="!canResetPassword"
                    @click="resetPassword"
                >
                    {{ lang('all.wachtwoord_vergeten') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../Shared/Layout";
import TextInput from "../../Common/TextInput";
import CheckboxInput from "../../Common/CheckboxInput";

export default {

    components: {
        TextInput,
        CheckboxInput,
    },

    computed: {
        canResetPassword() {
            return this.posting === false &&
                this.form.email !== '';
        },

        errors() {
            return this.$page.props.errors;
        },
    },

    data() {
        return {
            form:{
                email:'',
            },
            posting:false,
        }
    },

    layout:Layout,

    metaInfo() {
        return {
            title: 'Wachtwoord vergeten',
            meta: [
                {vmid:'keywords',name:'keywords',content:'wachtwoord vergeten,reset,wachtwoord,password'},
                {vmid:'description',name:'description',content:'Wachtwoord vergeten? Stel het wachtwoord opnieuw in.'},
            ],
        }
    },

    methods: {
        resetPassword() {
            if (!this.canResetPassword) {
                return;
            }
            this.posting = true;

            this.$inertia.post(this.route('guest.password.email'), this.form, {
                onFinish: () => this.posting = false,
            });
        },
    },

    name:'GuestForgotPassword',

}

</script>
